import type { CustomAttribute } from '@/types';
import type { PaginateAttributes } from '@/ui/LoadMore';
import { LoadMore } from '@/ui/LoadMore/LoadMore';

interface PaginationProps {
  type: 'loadMore' | 'infiniteScroll';
  onLoadMore: () => void;
  attributes: PaginateAttributes;
  customAttributes?: CustomAttribute;
  isBusy?: boolean;
  isLive?: boolean;
}

const Pagination = ({
  type,
  onLoadMore,
  attributes,
  isLive = false,
  isBusy = false,
  customAttributes,
}: PaginationProps) => {
  switch (type) {
    case 'loadMore':
    case 'infiniteScroll':
      return (
        <LoadMore
          onClick={onLoadMore}
          attributes={attributes}
          isBusy={isBusy}
          isLive={isLive}
          customAttributes={customAttributes}
        />
      );
  }
};

export default Pagination;
